const VISITOR = {
    MARKETING_CLOUD_ORG_ID: '8CF467C25245AE3F0A490D4C@AdobeOrg',
    TRACKING_SERVER: 'fandango.hb-api.omtrdc.net',
}
const APP_MEASUREMENT = {
    RSID: 'fanspincosandbox',
}

export { VISITOR, APP_MEASUREMENT }